import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import useFeatureToggles from "../../../../hooks/useFeatureToggles";
import type { DisputedFilterValue } from "./SuggestedChasableFiltersContext";

const DISPUTED_OPTIONS: { id: DisputedFilterValue; label: string }[] = [
  { id: "all", label: "All" },
  { id: "disputed", label: "Disputed" },
  { id: "not_disputed", label: "Not Disputed" },
];

type Props = {
  disputedFilter: DisputedFilterValue;
  onDisputedFilterChange(disputedFilter: DisputedFilterValue): void;
};

export function DisputedFilter({ disputedFilter, onDisputedFilterChange }: Props) {
  const { isDisputedEnabled } = useFeatureToggles();

  if (!isDisputedEnabled) return null;

  const value = DISPUTED_OPTIONS.find((opt) => opt.id === disputedFilter) ?? DISPUTED_OPTIONS[0];

  return (
    <Autocomplete
      size="small"
      options={DISPUTED_OPTIONS}
      value={value}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, v) => option.id === v.id}
      onChange={(_, newValue) => onDisputedFilterChange(newValue?.id ?? "all")}
      renderInput={(params) => <TextField {...params} label="Disputed" />}
      sx={{ minWidth: 200 }}
    />
  );
}
